<template>
    <section class="section-padding" id="contact">
        <div class="container-fluid container-lg">
            <div class="row justify-content-center align-items-center">
                <div class="col-12 text-center section-header">
                    <h2 class="mb-2">Contact Us</h2>
                    <p>Do not hesistate to reach out to us when you have a any question or suggestion</p>
                </div>
            </div>
            <div class="row justify-content-center align-items-center g-lg-4 mt-3 mt-lg-4 px-md-5 px-lg-0">
                <div class="col-lg-6 text-center">
                    <img class="img-fluid" src="../assets/contactimage.png" alt="Contact Image Left">
                </div>
                <div class="col-lg-6">
                    <div class="contact-form px-3 px-lg-0">
                        <form>
                            <div class="form-group mb-3">
                                <input class="form-control" v-model="
                                form.name" type="text" placeholder="Your Name" required>
                            </div>
                            <div class="form-group mb-3">
                                <input class="form-control" v-model="
                                form.email" type="email" placeholder="Your Email" required>
                            </div>
                            <div class="form-group mb-3">
                                <textarea class="form-control" v-model="
                                form.message" cols="10" rows="5" placeholder="Your Message" required></textarea>
                            </div>
                            <button @click.prevent="processContact" class="call-to-action" :disabled=processing>{{ processing ? "Sending..." : "Send" }}</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Api from '../api'

export default {
    data() {
        return {
            form: {
                email: "",
                name: "",
                message: ""
            },
            processing: false,
        }
    },
    methods: {
        async processContact() {
            this.processing = true
            if (!this.form.email || !this.form.name || !this.form.message) {
                this.$toast.error("Enter all required details", { position: "top-right" })
            }else{
                try{
                    await Api.post('/mail', this.form)
                    this.$toast.success("Message submitted sucessfully", { position: "top-right" })
                }catch(error){
                    this.$toast.error("An error occured", { position: "top-right" })
                }
            }
            this.form = {
                email: "",
                name: "",
                message: ""
            }
            this.processing = false
        }
    }
}
</script>

<style>
#contact h2 {
    font-size: 1.3rem;
    color: var(--dacode-primary-color);
}

textarea {
    resize: none;
}

.form-control::placeholder {
    font-size: .85rem !important;
}

.form-control:focus {
    box-shadow: 0 0 .25rem var(--dacode-primary-color) !important;
}

#contact .call-to-action {
    padding: .8rem 2rem;
}

input.form-control {
    height: 3rem;
}
</style>